import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAuth} from '../security/AuthContext';
import {Navbar, Nav, NavDropdown, Container} from 'react-bootstrap';
import {Settings, User} from 'lucide-react';
import './HeaderComponent.css';

function HeaderComponent() {
  const authContext = useAuth();
  const isAuthenticated = authContext.isAuthenticated;
  const navigate = useNavigate();

  const [showEmailDropdown, setShowEmailDropdown] = useState(false);
  const [showConnectionsDropdown, setShowConnectionsDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showHelpDropdown, setShowHelpDropdown] = useState(false);
  const [showRightProfileDropdown, setShowRightProfileDropdown] = useState(false);
  const [showRightSettingsDropdown, setShowRightSettingsDropdown] = useState(false);

  function logout() {
    authContext.logout();
  }



  return (
    <header className="header">
      <div className="container-1024">
        <Navbar bg="primary" variant="dark" expand="lg" className="p-0">
          <Container fluid className="p-0">
            <Navbar.Brand as={Link} to="/">KDL</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                {isAuthenticated && (
                  <>
                    <NavDropdown
                      title="Email"
                      id="email-dropdown"
                      className="custom-dropdown"
                      show={showEmailDropdown}
                      onMouseEnter={() => setShowEmailDropdown(true)}
                      onMouseLeave={() => setShowEmailDropdown(false)}
                    >
                      <NavDropdown.Item as={Link} to="/email/inbox">Inbox</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/email/sent">Sent</NavDropdown.Item>
                    </NavDropdown>


                    <NavDropdown
                      title="Connections"
                      id="connections-dropdown"
                      className="custom-dropdown"
                      show={showConnectionsDropdown}
                      onMouseEnter={() => setShowConnectionsDropdown(true)}
                      onMouseLeave={() => setShowConnectionsDropdown(false)}
                    >
                      <NavDropdown.Item as={Link} to="/connections/views">Viewed me</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/connections/winks">Winks at me</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/connections/favorites">My Favorites</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/connections/favorited-me">Favorited me</NavDropdown.Item>
                    </NavDropdown>

                    <Nav.Link as={Link} to="/search">Search</Nav.Link>



                  </>
                )}
              </Nav>


              {/* Right-side icons and dropdowns */}
              <Nav className="ms-auto">
                {isAuthenticated && (
                  <>
                    <NavDropdown
                      title={<Settings size={20} className="text-white" />}
                      id="settings-right-dropdown"
                      className="custom-dropdown icon-dropdown"
                      show={showRightSettingsDropdown}
                      onMouseEnter={() => setShowRightSettingsDropdown(true)}
                      onMouseLeave={() => setShowRightSettingsDropdown(false)}
                      align="end"
                    >
                      <NavDropdown.Item as={Link} to="/settings/account-settings">Account Settings</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/upgrade-membership">Upgrade Membership</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/blocked-members">Blocked Members</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item as={Link} to="/settings/privacy-policy">Privacy Policy</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/terms-of-use">Terms of Use</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/contact-us">Contact Us</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/remove-account">Remove Account</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/settings/update-password">Update Password</NavDropdown.Item>
                    </NavDropdown>

                    <NavDropdown
                      title={<User size={20} className="text-white" />}
                      id="profile-right-dropdown"
                      className="custom-dropdown icon-dropdown ms-2"
                      show={showRightProfileDropdown}
                      onMouseEnter={() => setShowRightProfileDropdown(true)}
                      onMouseLeave={() => setShowRightProfileDropdown(false)}
                      align="end"
                    >
                      <NavDropdown.Item as={Link} to="/profile/my-profile">My Profile</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/profile/edit-profile">Edit Profile</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/profile/manage-photos">Manage Photos</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/profile/add-photos">Add Photos</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item as={Link} to="/help/general">Help</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/help/dating-tips">Dating Tips</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/help/first-date">First Date</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={logout}>Sign out</NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
                {!isAuthenticated && (
                  <Nav.Link as={Link} to="/login">Login</Nav.Link>
                )}
              </Nav>



            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
}

export default HeaderComponent;